<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="52%"
            height="100%"
            class="modalDialog"
            no-click-animation
          >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-card-actions class="cardWrap__scroll">
                      <v-container>
                      <v-form
                        class="cardWrap__fromArea"
                        ref="form"
                        :lazy-validation="lazy"
                        @submit.prevent
                      >
                        <v-row justify="space-around" class="formHeight">
                          <div class="cardWrap__fromArea__title">退会理由</div>
                            <v-text-field
                              v-model="from_set_data.reason"
                              maxlength="256"
                              :rules="[rules.required]"
                              autofocus
                            />
                        </v-row>
                        <v-row justify="start" v-if="changeModeStatus">
                          <div class="cardWrap__fromArea__title">有効フラグ</div>
                          <v-checkbox v-model="from_set_data.valid_flag" class="mx-2" label="有効フラグ" />
                        </v-row>
                      </v-form>
                      </v-container>
                    </v-card-actions>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                      <v-btn color="green darken-4" text v-if="addModeStatus" @click="validateCheck">登録</v-btn>
                      <v-btn color="green darken-4" text v-if="changeModeStatus" @click="changeOverlay = !changeOverlay">変更</v-btn>
                    </v-card-actions>
                </v-card>
            </div>
            <AddOverlay
              page-name="退会理由"
              @processing="registerWithdrawalReason"
              @cancel="addOverlay = !addOverlay"
              :process-result="process"
              :overlay-switch="addOverlay"
            />
            <ChangeOverlay
              page-name="退会理由"
              @processing="updateWithdrawalReason"
              @cancel="changeOverlay = !changeOverlay"
              :process-result="process"
              :OverlaySwitch="changeOverlay"
            />
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import {
    REGISTER_WITH_DRAWAL_REASON,
    UPDATE_WITH_DRAWAL_REASON } from '@/constants/master';
import AddOverlay from '../overlay/AddOverlay';
import ChangeOverlay from '../overlay/ChangeOverlay';
import validater from '../../../../lib/validater';
import { InputPagesMixin } from './../mixin/InputPagesMixin';

export default {
    components: {
        CardTitle,
        AddOverlay,
        ChangeOverlay
    },
    mixins: [InputPagesMixin],
    props: ['editData'],
    data () {
        return {
            page_title: '退会理由登録',
            // 入力値
            from_set_data: {
                // 退会理由
                reason: '',
                // 有効フラグ
                valid_flag: ''
            },
            rules: {
                required: value => !!value || this.$t('error.validation.required.any'),
                // ゴルフ場コードバリデーション
                format_golf_code: value => !!validater.checkStringType(value) || this.$t('error.validation.stringtype'),
                // カナバリデーション
                format_kana: value => !!validater.checkKana(value) || this.$t('error.validation.kanaFormat'),
                // 郵便番号バリデーション
                format_zipcode: value => !!validater.checkZipCode(value) || this.$t('error.validation.zipCodeFormat'),
                min_length_tel: value => value.length >= 10 || this.$t('error.validation.length.tel'),
                // 電話番号バリデーション
                format_tel: value => !!validater.checkTel(value) || this.$t('error.validation.telFormat')
            }
        };
    },
    created () {
        this.Initialize();
    },
    computed: {
        addModeStatus () {
            return this.modeStatus === 'addMode';
        },
        changeModeStatus () {
            return this.modeStatus === 'changeMode';
        }
    },
    watch: {
        editData () {
            this.from_set_data.id = this.editData.id;
            this.from_set_data.reason = this.editData.reason;
            this.from_set_data.valid_flag = this.editData.valid_flag;
        },
        // modeStatusで表示を切り替える
        modeStatus () {
            if (this.modeStatus === 'addMode') {
                this.page_title = '退会理由登録';
            } else if (this.modeStatus === 'changeMode') {
                this.page_title = '退会理由変更';
            }
        }
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.addOverlay = false;
            this.changeOverlay = false;
            this.from_set_data = {
                id: '',
                reason: '',
                valid_flag: ''
            };
            this.process = {
                result: '',
                resultText: ''
            };
        },
        registerWithdrawalReason () {
            this.$apollo.mutate({
                mutation: REGISTER_WITH_DRAWAL_REASON,
                variables: {
                    reason: this.from_set_data.reason
                }
            }).then(res => {
                this.process.result = res.data.registerWithdrawalReasonCheckbox.result;
                this.CloseModal();
            }).catch(error => {
                this.error = error;
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.add');
                this.process.result = '';
            });
        },
        updateWithdrawalReason () {
            this.$apollo.mutate({
                mutation: UPDATE_WITH_DRAWAL_REASON,
                variables: {
                    id: this.from_set_data.id,
                    reason: this.from_set_data.reason,
                    valid_flag: this.from_set_data.valid_flag
                }
            }).then(res => {
                this.process.result = res.data.updateWithdrawalReasonCheckbox.result;
                this.CloseModal();
            }).catch(error => {
                this.error = error;
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.change');
                this.process.result = '';
            });
        },
        validateCheck () {
            if (this.$refs.form.validate()) {
                if (this.modeStatus === 'addMode') {
                    this.addOverlay = true;
                } else if (this.modeStatus === 'changeMode') {
                    this.changeOverlay = true;
                }
            }
        },
        /** ----------------------------------------------
         * 親画面にて「追加」ボタン押下時の処理
         * ---------------------------------------------- */
        addModal () {
            this.Initialize();
            this.dialog = true;
            this.modeStatus = 'addMode';
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        editModal () {
            this.Initialize();
            this.dialog = true;
            this.modeStatus = 'changeMode';
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.dialog = false;
            this.$refs.form.resetValidation();
            this.$emit('refresh-event');
            this.Initialize();
        }
    }
};
</script>

<style scoped>

.formHeight{
  max-height: 60px;
  max-width: 100%;
}

</style>
